import { ContactFilterType } from 'modules/contacts/types/contact-filter-interface'
import { getDefaultFilterValue } from 'modules/contacts/utils/get-default-filter-value'
import { deepCompare } from 'shared/utils/deepCompare'

export const isFilterFiledEmpty = ({ filter, slug }: { filter: ContactFilterType; slug: string }) =>
  deepCompare(getDefaultFilterValue(slug), filter[slug])
